// App
import React from 'react';

// Constellation
import { Radio, Text } from '@zillow/constellation';

import * as S from './styles';

// Types
type PriceCardPropTypes = {
  description: string;
  handleClick?: () => void;
  isActive: boolean;
  isDisabled?: boolean;
  title: string;
};

const PriceCard = ({
  description,
  isDisabled = false,
  handleClick = () => {},
  isActive,
  title,
}: PriceCardPropTypes) => {
  const text = (
    <S.PriceCardText>
      <Text fontType="bodyHeading">{title}</Text>
      <Text as="div" fontType="bodySmall" fontColor="gray400">
        {description}
      </Text>
    </S.PriceCardText>
  );
  return isDisabled ? (
    <S.PriceCardContainerDisabled>{text}</S.PriceCardContainerDisabled>
  ) : (
    <S.PriceCardContainer isActive={isActive} onClick={handleClick}>
      <Radio name="distance" checked={isActive} onChange={() => {}} style={{ minWidth: '20px', marginRight: '8px' }} />
      {text}
    </S.PriceCardContainer>
  );
};

export default PriceCard;
